/**
 * Created by ivo on 12.05.17.
 */
import alt from '../alt';
import BaseRestActions from '../BaseRestActions';

class SessionActions extends BaseRestActions {
    /**
     * Get access token
     * @param authToken
     * @returns {*}
     */
    login(authToken) {
        return authToken;
    }

    logout() {
        return null;
    }

    /**
     * Call when current session is expired and should not used anymore
     */
    sessionExpired() {
        return null;
    }

    startAuthentication(nonce) {
        return nonce;
    }

    setPasswordTab(name) {
        return name;
    }

    updateSession(session) {
        return session;
    }

    changePassword(action) {
        return action;
    }
}

/**
 *
 * @type {SessionActions}
 */
let sessionActions = alt.createActions(SessionActions);

export default sessionActions;
